/**
 * SeriesExtended Page.
 */
import Rail from '@shared/classes/rail';
import Main from '@shared/types/enums/main';
import MainTemplate from '@components/templates/main/ui/main';
import seriesObservable from '@shared/api/series/seriesObservable';
import useComplete from '@shared/components/utils/hooks/useComplete';
import { Subscription, Observer } from 'rxjs';
import { channelsSelector } from '@shared/store/slices/channels.slice';
import { genresSelector } from '@shared/store/slices/genres.slice';
import { selectCurrentParams } from '@shared/store/slices/router.slice';
import { useAppSelector } from '@shared/store/hooks';
import { useEffect, useState } from 'react';
import { userSelector } from '@shared/store/slices/user.slice';

/**
 * Displays the series extended page with the rails
 */
export default function SeriesExtended() {
  const { channelsData } = useAppSelector(channelsSelector);
  const { data: genresData } = useAppSelector(genresSelector);
  const { initialized } = useAppSelector(userSelector);
  const currentParams = useAppSelector(selectCurrentParams);

  const [complete, setComplete] = useComplete();
  const [rails, setRails] = useState<Rail[]>(
    (currentParams as { rails: Rail[] })?.rails || []
  );

  useEffect(() => {
    let subscription: Subscription;
    if (initialized && channelsData?.length && genresData?.length) {
      const initialObserver: Observer<{
        data: Rail[];
        type: Main;
      }> = {
        next: (val) => {
          if (val.type === Main.RAILS) {
            setRails(val.data as Rail[]);
          }
        },
        error: () => {
          console.error('Error recovering series');
        },
        complete: () => {
          setComplete(true);
          return null;
        },
      };
      subscription = seriesObservable(
        (currentParams as { id: string })?.id
      ).subscribe(initialObserver as Partial<Observer<unknown>>);
    }
    return () => {
      subscription?.unsubscribe();
    };
  }, [initialized, channelsData, genresData]);

  return <MainTemplate flags={{ complete }} rails={rails} />;
}
